import React from 'react';
import { Button, Typography } from 'antd';
import { ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout';

const { Title, Text } = Typography;

const PORTAL_URL = 'https://futpremia.com/';

const REASONS = {
  'not-found': {
    icon: <ExclamationCircleOutlined style={{ fontSize: 64, color: '#ff4d4f', marginBottom: 24 }} />,
    title: 'Plan no encontrado',
    message: 'El plan que seleccionaste no está disponible en este momento.',
  },
  'already-subscribed': {
    icon: <InfoCircleOutlined style={{ fontSize: 64, color: '#1677ff', marginBottom: 24 }} />,
    title: 'Ya tienes una membresía activa',
    message: 'Tu cuenta ya cuenta con una membresía activa o pendiente de confirmación. No es posible adquirir otra mientras esté vigente.',
  },
  'error': {
    icon: <ExclamationCircleOutlined style={{ fontSize: 64, color: '#ff4d4f', marginBottom: 24 }} />,
    title: 'Algo salió mal',
    message: 'Ocurrió un error al procesar tu solicitud. Por favor inténtalo de nuevo más tarde.',
  },
};

export default function CheckoutErrorPage() {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') || 'error';
  const content = REASONS[reason] ?? REASONS['error'];

  return (
    <AuthLayout>
      <div style={{ textAlign: 'center', padding: '48px 24px' }}>
        {content.icon}
        <Title level={2} style={{ color: '#fff', marginBottom: 8 }}>
          {content.title}
        </Title>
        <Text style={{ color: 'rgba(255,255,255,0.65)', display: 'block', marginBottom: 32 }}>
          {content.message}
        </Text>
        <Button type="primary" size="large" href={PORTAL_URL}>
          Volver al portal
        </Button>
      </div>
    </AuthLayout>
  );
}
